// extracted by mini-css-extract-plugin
module.exports = {"image-container":"imageResponsive_image-container__yEN8_","image":"imageResponsive_image__nZL1D"};